import * as stylex from "@stylexjs/stylex";
import { type Breakpoint, layoutSize } from "@/domain/breakpoint";
type Span = {
  top: number;
  bottom: number;
};
export const THUMB_REVEAL_PX = 12;
const grids = {
  large: {
    kumcoG: "x233cl8",
    k9llMU: "x5o4joa",
    kZKoxP: "x5yr21d",
    kAzted: "x1us19tq",
    $$css: true
  },
  small: {
    kumcoG: "x1mkdm3x",
    $$css: true
  }
};
const featured = {
  large: {
    kAzted: "xz65tgg",
    $$css: true
  },
  small: {
    kAzted: "x1xaied3",
    $$css: true
  }
};
const panels = {
  large: {
    kZKoxP: "xqtp20y",
    kAzted: "x1us19tq",
    $$css: true
  },
  small: {
    $$css: true
  }
};
const thumbs = {
  two: {
    kumcoG: "xnby9oq",
    $$css: true
  }
};
export function photosLayout(breakpoint: Breakpoint) {
  const size = layoutSize(breakpoint);
  return {
    grid: grids[size],
    featured: featured[size],
    panel: panels[size],
    thumbs: thumbs.two
  };
}
export function revealDelta(view: Span, item: Span, pad: number): number {
  if (item.top < view.top + pad) return item.top - view.top - pad;
  if (item.bottom > view.bottom - pad) return item.bottom - view.bottom + pad;
  return 0;
}